import { queryOptions } from '@tanstack/react-query';
import { listBrandFonts, type ListBrandFontsQuery } from './brandFont.api';

/* eslint-disable i18next/no-literal-string -- cache key segments, not copy */
export const BRAND_FONT_QUERY_KEYS = {
  all: ['brand-font'] as const,
  list: (query: ListBrandFontsQuery = {}) => ['brand-font', 'list', query] as const,
};
/* eslint-enable i18next/no-literal-string */

/**
 * The workspace's fonts, narrowed the way the media listing beside them is.
 *
 * The narrowing is part of the key, so standing in a folder and standing in the whole library are
 * two cached answers rather than one that the last fetch happened to leave behind.
 *
 * No `staleTime`, matching `brandMediaQueryOptions`: an upload's own effect must be visible on
 * refetch.
 */
export const brandFontsQueryOptions = (query: ListBrandFontsQuery = {}) =>
  queryOptions({
    queryKey: BRAND_FONT_QUERY_KEYS.list(query),
    queryFn: () => listBrandFonts(query),
  });
